import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Garment from './Garment/index.jsx';
import styles from './style.module.scss';

class GarmentContainer extends Component {
	render() {
		const { garments } = this.props

		const renderGarment = (garment, index) => {
			return (
				<div className={styles.garment}>
					<Garment
						key={garment.name}
						image={garment.image}
						name={garment.name}
						onClick={() => this.props.onClick(garment, index)}
					/>
				</div>
			)
		}

		return (
			<div 
				className={styles.container}>
				<div className={styles.lookbook}>
					{!garments.length ? 
						<h2 className={styles.error}>
							Your search criteria did not return any garments, please try again!
						</h2>:
						garments.map((garment, index) => renderGarment(garment, index))
					}
				</div>
			</div>
		)
	}
}

GarmentContainer.propTypes = {
	garments: PropTypes.array.isRequired,
	onClick: PropTypes.func.isRequired,
}

export default GarmentContainer;